import React from "react";
import styled from "styled-components";
import SearchIcon from "@mui/icons-material/Search";
import { useForm } from "react-hook-form";
import { IconButton } from "@mui/material";
import { characterSearchFieldsGet } from "common/character/character_search";
import SearchText from "components/common/search_sort/SearchText";
import SearchSort from "components/common/search_sort/SearchSort";
import { SEARCH_NAMES } from "constant/search/search";
import CheckboxField from "components/UI/CheckboxField";

type CharacterSearchFiltersProps = {
  searchHandle: Function;
};

const defaultVals: any = characterSearchFieldsGet();

const CharacterSearchFilters = ({
  searchHandle,
}: CharacterSearchFiltersProps) => {
  const { handleSubmit, control, setValue } = useForm({
    defaultValues: defaultVals,
  });

  const handleTopicSearchCheckboxChange = (val: any) => {
    setValue(SEARCH_NAMES.SEARCH_ALSO_IN_OTHER_TOPICS, val);
  };

  const onSubmit = async (data: any) => {
    console.log(data);
    searchHandle(data);
  };

  return (
    <div>
      <DivSearchOrder>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <SearchText
            fieldName={SEARCH_NAMES.SEARCH_TEXT}
            defaultValue={defaultVals[SEARCH_NAMES.SEARCH_TEXT]}
            label="Tekst pretrazivanja"
            control={control}
          />
          <SearchSort
            control={control}
            sortByName={SEARCH_NAMES.SORT_BY}
            sortOrderName={SEARCH_NAMES.SORT_ORDER}
            sortByDefaultValue={""}
            sortOrderDefaultValue={""}
          />

          <DivTopicSearchCheckboxField>
            <CheckboxField
              label="Search also in other topics"
              onChange={handleTopicSearchCheckboxChange}
            />
          </DivTopicSearchCheckboxField>

          <DivSubmit>
            <IconButton type="submit">
              <SearchIcon />
            </IconButton>
          </DivSubmit>
        </Form>
      </DivSearchOrder>
    </div>
  );
};

const DivSearchOrder = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;

  svg {
    cursor: pointer;
  }
  svg:hover {
    opacity: 0.8;
  }
`;

const Form = styled.form`
  &&& {
    display: flex;
    align-items: center;
  }
`;

const DivTopicSearchCheckboxField = styled.div`
  margin-left: 1rem;
`;

const DivSubmit = styled.div`
  margin-left: 1.5rem;
  display: flex;
`;

export default CharacterSearchFilters;
